import {createSlice} from '@reduxjs/toolkit';
import {FormProductInit} from "./model";
const R = require('ramda');

const initialState = {
    categories: [],
    categoryForm: FormProductInit,
};

const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        setCategories: (state, action) => {
            state.categories = action.payload;
        },
        setCurrentCategory: (state, action) => {
            state.categoryForm = action.payload;
        },
        onCategoryFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.categoryForm[name] = value;
        },
        initCategoryForm: (state, action) => {
            state.categoryForm = FormProductInit;
        },
    },
});

export const {actions} = categorySlice;
export const {
    setCategories,
    setCurrentCategory,
    onCategoryFormChange,
    initCategoryForm,
} = actions;

// reducers

// selectors
export const selCategories = (state) => state.category.categories;
export const selCategoryForm = (state) => state.category.categoryForm;

const categoryReducer = {
    category: categorySlice.reducer,
};
export default categoryReducer;
